export const memowlV2FirebaseConfig = {
    apiKey: 'AIzaSyDRVZcqvw5ndjK7G4aDSh0nPZZh0J8t2ZE',
    authDomain: 'memowl-version-2.firebaseapp.com',
    projectId: 'memowl-version-2',
    storageBucket: 'memowl-version-2.appspot.com',
    messagingSenderId: '41891322947',
    appId: '1:41891322947:web:75c7806168eb6490ac48f6',
    measurementId: 'G-4B0Y5GT2E4',
};
